import {
  Alert,
  Classes,
  Dialog,
  HTMLSelect,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import { AssinaturaStore } from "../../stores/assinatura/AssinaturaStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { PerfilStore } from "../../stores/perfil/PerfilStore";
import {
  MDBBtn,
  MDBCol,
  MDBRow,
} from "mdbreact";
import {
  SearchField,
} from "react-bootstrap-table";
import CalculadoraPage from "../calculadora/Calculadora";
import { sortBy } from "../../utils";
import LoadingModal from "../loading/LoadingModal";

const numeral = require("numeral");

@observer
export class AssinaturaPendentePage extends React.Component<{}, {}> {
  obs = observable({
  })

  constructor(props: any) {
    super(props);
  }

  async componentDidMount() {
    AppStore.setTitle("Sua Assinatura está Pendente");

    // PerfilStore.load();

  }

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="input-filter"
        defaultValue={props.defaultSearch}
        placeholder="Filtre um CNPJ"
      />
    );
  };

  async handleUpdatePlano() {

    let data = {
      cnpj: EmpresaStore.obs.cnpj,
      plano: EmpresaStore.obs.plano
    }

    await EmpresaStore.putPlano(data);

    EmpresaStore.obs.open_calculadora = false;

  }


  handleCloseCalculadora() {
    EmpresaStore.obs.open_calculadora = false;
    EmpresaStore.obs.rendimento_mensal = 0
    EmpresaStore.obs.valorPlano = null
    EmpresaStore.obs.plano = []
  }

  handleSetOff(cnpj: string) {

    EmpresaStore.obs.cnpj = cnpj

    EmpresaStore.obs.open_calculadora = true;

  }

  render() {
    let is_teste = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.teste : false;

    let rows = sortBy(EmpresaStore.obs.empresas_all, "razao_social")?.map((emp) => {
      return (
        <tr key={emp.cnpj}>
          <td style={{ fontSize: 10 }}>
            {emp.razao_social}
          </td>
          <td style={{ fontSize: 10 }}>
            {emp.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")}
          </td>
          <td style={{ fontSize: 10 }}>
            {emp.plano && emp.plano.length > 0 ? emp.plano[0].nome ? emp.plano[0].nome : `Faixa ${emp.plano[0].faixa}` : ""}
          </td>
          <td style={{ fontSize: 10 }}>
            {numeral(emp.plano && emp.plano.length > 0 ? emp.plano[0].valor : 0).format("$ 0,0.00")}
          </td>
          <td>
            <span className="btn_plano" onClick={() => this.handleSetOff(emp.cnpj)}>Alterar</span>
          </td>
        </tr>
      );
    },
    );

    return (
      <>

        <div className="dashboard-page">

          <LoadingModal open={AssinaturaStore.obs.progressIugu} onClose={() => AssinaturaStore.obs.progressIugu = false} title={"Processando assinatura"} />

          <MDBRow>
            <MDBCol md="12">
              <p>
                Detectamos que você não possui uma assinatura vinculada a sua
                conta.
              </p>
              <p>
                Abaixo listamos as empresas e pedimos que selecione o plano
                correspondente para cada uma.
              </p>

              <div className="bloco-perfil">
                <MDBRow>
                  <MDBCol md="12">
                    <div className="emp-plans">
                      <table style={{ width: "100%" }}>
                        <thead>
                          <tr>
                            <th style={{ width: "50%" }}>Razão Social</th>
                            <th style={{ width: "20%" }}>CNPJ</th>
                            <th style={{ width: "20%" }}>Plano</th>
                            <th style={{ width: "20%" }}>Valor</th>
                            <th />
                          </tr>
                        </thead>
                        <tbody>
                          {rows}
                        </tbody>
                      </table>
                    </div>
                  </MDBCol>
                </MDBRow>
              </div>

              {is_teste &&
                <div style={{ width: "100%" }}>
                  <MDBBtn
                    className="btnDefault btnBuscarNfe"
                    style={{ float: "right", marginTop: 10 }}
                    onClick={() => AppStore.setLocation("/assinar-plano")}>
                    Etapa 2: Ativar seu plano!
                  </MDBBtn>
                </div>
              }

              <div style={{ marginTop: 5, marginBottom: 110 }} />

            </MDBCol>
          </MDBRow>
        </div>

        <Alert
          cancelButtonText="Fechar"
          confirmButtonText="Salvar"
          isOpen={EmpresaStore.obs.open_calculadora}
          onCancel={() => this.handleCloseCalculadora()}
          onConfirm={() => this.handleUpdatePlano()}
          className="AlertUser"
          intent="primary"
        >
          <div style={{ display: 'ruby' }}>
            <img className="iconSEFAZ" src="/images/calculadora.png" width="40px" />
            <h2 className="titleSEFAZ">Selecione seu Plano</h2>
          </div>
          <CalculadoraPage />
        </Alert>

      </>

    );
  }
}

export default AssinaturaPendentePage;
